import React, { useState, useEffect } from 'react';
import '../../../views/stylesheet/styles.css';
import { NavLink, useLocation } from 'react-router-dom';
import meetRoomIcon from './Images/meetRoom.svg';
import meetRoomSelect from './Images/meetRoomSelect.svg';
import { useMediaQuery } from 'react-responsive';
import cookie from "react-cookies";
import { IconDashboard, IconBook, IconUsers, IconGitBranch, IconBuildingArch, IconHome2, IconUserCheck } from '@tabler/icons';

function MenuItems({ close }) {
    const Type = cookie.load("type");
    const location = useLocation();
    const isMobile = useMediaQuery({ query: `(max-width:760px)` });
    const [List, setList] = useState([
        {
            id: 'default',
            title: 'Dashboard',
            type: 'item',
            url: '/dashboard',
            icon: <IconDashboard width="1.3rem" height="1.3rem" />,
            breadcrumbs: false,
            isActive: false
        },

        {
            id: 'Meeting',
            title: 'Meeting Rooms',
            type: 'item',
            url: '/meetingRooms',
            icon: <img src={meetRoomIcon} alt="meetRoom" width="20px" />,
            icon2: <img src={meetRoomSelect} alt="meetRoom2" width="20px" />,
            breadcrumbs: false,
            isActive: false
        },
        {
            id: 'branches',
            title: 'Branches',
            type: 'item',
            url: '/branches',
            icon: <IconGitBranch width="1.3rem" height="1.3rem" />,
            breadcrumbs: false,
            isActive: false
        },

        {
            id: 'Booking',
            title: 'Bookings',
            type: 'item',
            url: '/bookings',
            icon: <IconBook width="1.3rem" height="1.3rem" />,
            breadcrumbs: false,
            isActive: false
        },

        {
            id: 'Users',
            title: 'Users',
            type: 'item',
            url: '/users',
            icon: <IconUsers width="1.3rem" height="1.3rem" />,
            breadcrumbs: false,
            isActive: false
        },
        {
            id: 'cities',
            title: 'Cities',
            type: 'item',
            url: '/cities',
            icon: <IconBuildingArch width="1.3rem" height="1.3rem" />,
            breadcrumbs: false,
            isActive: false
        },
        {
            id: 'amenities',
            title: 'Amenities',
            type: 'item',
            url: '/amenities',
            icon: <IconHome2 width="1.3rem" height="1.3rem" />,
            breadcrumbs: false,
            isActive: false
        },
        {
            id: 'managers',
            title: 'Managers',
            type: 'item',
            url: '/managers',
            icon: <IconUserCheck width="1.3rem" height="1.3rem" />,
            breadcrumbs: false,
            isActive: false
        }
    ]);

    const closeDrawer = () => {
        {
            isMobile && close();
        }
    };
    useEffect(() => {
        const list = [...List];

        List.map((item, i) =>
            location.pathname.startsWith(item.url)
                ? ((list[i].isActive = true), setList(list))
                : ((list[i].isActive = false), setList(list))
        );

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);
    return (
        <div>
            <div className="sideBar">
                {Number(Type) === Number(1) ? (List.map((item) => (
                    <div key={item.id}>
                        <NavLink
                            to={item.url}
                            className={item.isActive ? 'list_active sideBar_listing' : 'sideBar_listing'}
                            onClick={() => closeDrawer()}
                        >
                            <div className="sideBar_list_icon">{item.isActive ? (item.icon2 ? item.icon2 : item.icon) : item.icon}</div>
                            <div>{item.title}</div>
                        </NavLink>
                    </div>
                ))) : (List.filter(item => item.url === "/bookings").map((item) => (
                    <div key={item.id}>
                        <NavLink
                            to={item.url}
                            className={item.isActive ? 'list_active sideBar_listing' : 'sideBar_listing'}
                            onClick={() => closeDrawer()}
                        >
                            <div className="sideBar_list_icon">{item.icon}</div>
                            <div>{item.title}</div>
                        </NavLink>
                    </div>
                )))}
            </div>
        </div>
    );
}

export default MenuItems;
